module.exports = __webpack_public_path__ + "static/fonts/Oswald-DemiBold.6da7b52.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-DemiBold.ttf
// module id = L22V
// module chunks = 1